export function padLeft(x, size, character = "0") {
  let result = "" + x;
  while(result.length < size) {
    result = character + result;
  }
  return result;
}

export function padRight(x, size, character = "0") {
  let result = "" + x;
  while(result.length < size) {
    result = result + character;
  }
  return result;
}